import {entityList, entityDelete, entitySave, executeCall} from './CallService';

export const projectList = async () => {
    return await entityList('project')
}

export const projectViewList = async (query) => {
    const action = "query";
    const data = {query: query};
    return await executeCall(action, data);
}

export const projectTaskList = async(projectId) => {
    const action = "query";
    const data = {
        query: "projectTask",
        params: {
            projectId: projectId
        }
    };
    return await executeCall(action, data);
}

export const archiveTaskList = async(projectId) => {
    const action = "query";
    const data = {
        query: "archiveTask",
        params: {
            projectId: projectId
        }
    };
    return await executeCall(action, data);
}


export const projectSearchList = async(searchParams, current) => {
    const action = "query.dml";
    const data = {
        query: "projectSearchList",
        current: current,
        params: searchParams
    };
    return await executeCall(action, data);
}

export const projectSave = async(dbValues) => {
    return entitySave("project", dbValues);
}

export const projectDelete = async(projectId) => {
    return entityDelete("project", projectId);
}
